// removed by extract-text-webpack-plugin
module.exports = {"modal":"mYPnhqec9DKsR4vgYjFsB","content":"a7fCcPvt7dLyQfS4rG_Wv","subtitle":"_1qCBcPH13O-z2qyS84zIq5","btnWrap":"aBdL-BFi1J3JbCuhlaOei","button":"GsUVYQCcbQWvUjTSUIto5","info":"_1u0tGVcfAh6obTg9R8IyDY"};


//////////////////
// WEBPACK FOOTER
// ./src/client/Components/ExtraUserInformation/ExtraUserInformation.css
// module id = 93
// module chunks = 58